<template>
  <v-dialog
      v-model="showDialog"
      max-width="1500px"
      persistent
      scrollable
  >
    <v-card>
      <v-card-title>
        Rufbereitschaftsplan bearbeiten
        <v-spacer></v-spacer>
      </v-card-title>

      <div class="scheduler-wrapper">
        <v-simple-table dense class="scheduler-table">
          <template v-slot:default>
            <thead>
            <tr>
              <th class="sticky-col-header text-center font-weight-bold" style="min-width: 100px;">
                Stunden
              </th>
              <th
                  v-for="(timeLabel, index) in timeLabels"
                  :key="index"
                  class="text-left caption px-1"
                  style="min-width: 50px"
                  colspan="2"
              >
                {{ timeLabel }}
              </th>
            </tr>
            <tr>
              <th class="sticky-col-header text-center font-weight-bold" style="min-width: 100px;">
                Datum
              </th>
              <th
                  v-for="(a, index) in timeLabels"
                  :key="index + '_time'"
                  class="text-center caption px-1"
                  style="min-width: 50px"
                  colspan="2"
              >
                {{ '30' }}
              </th>
            </tr>
            </thead>

            <tbody @mouseleave="endSelection">
            <tr v-for="(day, dayIndex) in gridData" :key="day.dateStr">
              <td class="sticky-col font-weight-bold text-no-wrap">
                {{ day.formattedDate }}
              </td>

              <td
                  v-for="(slot, slotIndex) in day.slots"
                  :key="slotIndex"
                  class="time-cell"
                  :class="{
                    'selected-cell': slot.selected,
                    'in-drag-zone': isCellInDragZone(dayIndex, slotIndex)
                  }"
                  @mousedown.prevent="startSelection(dayIndex, slotIndex)"
                  @mouseover="updateSelection(dayIndex, slotIndex)"
                  @mouseup="endSelection"
              >
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="blue darken-1"
            text
            @click="showDialog = false;"
        >
          Abbrechen
        </v-btn>
        <v-btn
            color="blue darken-1"
            text
            @click=""
        >
          Speichern
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
export default {
  name: 'SchedulerTable',
  props: {
    startDate : {
      type: String,
      required: false,
      default: () => {
        const now = new Date();
        let d =  new Date(now.getFullYear(), now.getMonth(), 1, 12);
        // format as yyyy-mm-dd
        return d.toISOString().split('T')[0];
      }
    },
    endDate : {
      type: String,
      required: false,
      default: () => {
        const now = new Date();
        let d =  new Date(now.getFullYear(), now.getMonth() + 1, 0, 12);
        // format as yyyy-mm-dd
        return d.toISOString().split('T')[0];
      }
    },
    mitas: {
      type: Array,
      required: true,
      default: () => []
    },
    raster: {
      type: Object,
      required: false,
      default: () => null
    }
  },
  data() {
    return {
      isSelecting: false,
      dragStartIndex: -1,   // Linear index (dayIndex * 48 + slotIndex)
      dragCurrentIndex: -1, // Linear index
      gridData: [],
      timeLabels: [],
      slotsPerDay: 48,
      showDialog: false
    };
  },
  created() {

  },
  methods: {
    show() {
      this.showDialog = true;
      this.initializeGrid();
    },
    initializeGrid() {
      // 1. Time Labels
      const labels = [];
      for (let i = 0; i < this.slotsPerDay; i++) {
        const hour = Math.floor(i / 2).toString();
        const minute = i % 2 === 0 ? '00' : '30';
        if (i % 2 === 0) {
          labels.push(i % 2 === 0 ? `${hour}` : '');
        }
      }
      console.log(this.startDate)
      console.log(this.startEndDate)
      this.timeLabels = labels;
      // 2. Generate Days (Native Date)
      const loop = new Date(this.startDate);
      loop.setHours(12)
      const end = new Date(this.endDate);
      end.setHours(12)
      const rows = [];

      while (loop <= end) {
        const dayName = loop.toLocaleDateString('de-DE', { day:'2-digit', month:'2-digit'});
        const dayNum = loop.toLocaleDateString('de-DE', {weekday: 'long' });

        rows.push({
          formattedDate: `${dayName} ${dayNum}`,
          slots: Array.from({ length: this.slotsPerDay }, () => ({ selected: false }))
        });

        // 2. Next Day
        loop.setDate(loop.getDate() + 1);
      }
      this.gridData = rows;
    },

    // --- LINEAR INDEX HELPER ---
    getLinearIndex(dayIndex, slotIndex) {
      return (dayIndex * this.slotsPerDay) + slotIndex;
    },

    startSelection(dayIndex, slotIndex) {
      this.isSelecting = true;
      const idx = this.getLinearIndex(dayIndex, slotIndex);
      this.dragStartIndex = idx;
      this.dragCurrentIndex = idx;
    },

    updateSelection(dayIndex, slotIndex) {
      if (this.isSelecting) {
        this.dragCurrentIndex = this.getLinearIndex(dayIndex, slotIndex);
      }
    },

    endSelection() {
      if (!this.isSelecting) return;

      const minIdx = Math.min(this.dragStartIndex, this.dragCurrentIndex);
      const maxIdx = Math.max(this.dragStartIndex, this.dragCurrentIndex);

      // Convert linear bounds back to coordinates to iterate efficiently
      const startDay = Math.floor(minIdx / this.slotsPerDay);
      const endDay = Math.floor(maxIdx / this.slotsPerDay);

      for (let d = startDay; d <= endDay; d++) {
        // If it's the first day, start at the calculated slot, otherwise start at 0 (00:00)
        const startSlot = (d === startDay) ? (minIdx % this.slotsPerDay) : 0;

        // If it's the last day, end at the calculated slot, otherwise end at 47 (23:30)
        const endSlot = (d === endDay) ? (maxIdx % this.slotsPerDay) : (this.slotsPerDay - 1);

        for (let s = startSlot; s <= endSlot; s++) {
          this.gridData[d].slots[s].selected = !this.gridData[d].slots[s].selected;
        }
      }

      this.isSelecting = false;
      this.dragStartIndex = -1;
      this.dragCurrentIndex = -1;
    },

    isCellInDragZone(dayIndex, slotIndex) {
      if (!this.isSelecting) return false;

      const cellLinearIdx = this.getLinearIndex(dayIndex, slotIndex);
      const min = Math.min(this.dragStartIndex, this.dragCurrentIndex);
      const max = Math.max(this.dragStartIndex, this.dragCurrentIndex);

      return cellLinearIdx >= min && cellLinearIdx <= max;
    }
  }
};
</script>

<style scoped>
/* Scroll handling */
.scheduler-wrapper {
  overflow-x: auto;
  max-height: 80vh; /* Allow vertical scroll for the month */
  position: relative;
  border: 1px solid #e0e0e0;
}

.scheduler-table {
  border-collapse: separate;
  border-spacing: 0;
}

/* Sticky First Column (Dates) */
.sticky-col {
  position: sticky;
  left: 0;
  background-color: white;
  z-index: 2;
  border-right: 1px solid #e0e0e0;
  border-bottom: 1px solid #f0f0f0; /* Row separator */
}

/* Sticky Header (Times) */
.sticky-col-header {
  position: sticky;
  left: 0;
  z-index: 3 !important;
  background-color: white;
}

thead tr th {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1;
  box-shadow: 0 1px 0 0 #e0e0e0; /* Border bottom for sticky header */
}

/* Cell Styles */
::v-deep .time-cell {
  cursor: pointer;
  user-select: none;
  border-right: 1px solid #f5f5f5;
  border-bottom: 1px solid #f5f5f5;
  transition: background-color 0.05s;
  padding: 0 !important;
  height: 30px !important;
  min-width: 20px;
  max-width: 20px !important;
  width: 20px !important;
}

/* Selected State (Persisted) */
.selected-cell {
  background-color: #4CAF50 !important; /* Green */
}

/* Dragging Preview (Transient) */
.in-drag-zone {
  background-color: rgba(33, 150, 243, 0.5) !important; /* Semi-transparent Blue */
}

/* Visual Feedback: Toggling OFF */
/* If a cell is green but currently inside the drag selection, show red so user knows it flips to off */
.selected-cell.in-drag-zone {
  background-color: #ef5350 !important; /* Red */
}

::v-deep .v-dialog__content--active {
  z-index: 1500 !important;
}

</style>
